import { PmcSource } from './schema';

export const PMC_SOURCE_OPTIONS: Record<PmcSource, { label: string; description: string }> = {
  MINISTRY_OF_HEALTH: {
    label: 'Usar Ministério da Saúde como base',
    description: 'Usamos o PMC publicado pelo Ministério da Saúde, tratado pela Infoprice. É a fonte padrão.',
  },
  CLIENT_ERP: {
    label: 'Usar ERP do cliente como base',
    description: 'Usamos o PMC que vem do seu ERP, com o tratamento por unidade que você já aplica. Esse dado precisa estar incluído na integração de dados.',
  },
};
